module.exports = __webpack_public_path__ + "img/coloredCircle.f45bed83.svg";